import { alpha, Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  container: { display: "flex", width: "100%", height: "100%" },
  containerTree: {
    display: "flex",
    justifyContent: "start",
    alingItems: "center",
    flexDirection: "column" as const,
    height: "100%",
    minWidth: "340px",
  },
  headerTree: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 3,
    height: "fit-content",
    paddingBottom: 0,
  },
  boxDropTreeAndTree: {
    width: "100%",
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
  },
  tree: (height: number) => ({
    display: "flex",
    width: "calc(100% - 48px)",
    position: "absolute",
    borderRadius: "5px",
    zIndex: 100,
    top: "24px",
    flexDirection: "column" as const,
    height: "fit-content",
    maxHeight: height - 24,
    overflowY: "auto",
  }),
  boxDropTree: {
    width: "100%",
    height: "100%",
    borderRadius: 1,
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
    flexDirection: "column" as const,
  },
  title: { mb: 2, fontSize: "1.2rem" },
  title2: (color?: string) => ({
    fontSize: "1.1rem",
    display: "flex",
    alignItems: "center",
    gap: 1,
    ...(color && { color }),
  }),
  subtitle: {
    color: theme.palette.text.disabled,
    mt: 2,
    width: "500px",
    textAlign: "center",
  },
  divider: { fontSize: "1.2rem", m: 0 },
  containerAccordions: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3,
  },
  accordion: (expanded: true | false) => ({
    padding: "0px 5px",
    borderRadius: 1,
    width: "100%",
    minWidth: "100%",
    backgroundColor: theme.palette.background.card,
    boxShadow: "0px 0px 5px #0000001a",
    border: "none",
    // height: "100%",
    ...(expanded && { height: "100%", overflowY: "auto" }),
    "&::before": {
      display: "none",
    },
    // "&:hover": {
    //   backgroundColor:
    //     // expanded == index
    //     //   ? "none"
    //     //   :
    //     alpha(theme.palette.text.secondary, 0.1),
    // },
  }),
  boxEmpty: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    "&.MuiCollapse-wrapper ": {
      height: "100%",
    },
    "&.MuiCollapse-root": {
      height: "100%",
    },
    "&.MuiCollapse-root .MuiCollapse-vertical": {
      height: "100%",
    },
    // "&.Mui-expanded": {
    //   minHeight: 15,
    //   maxHeight: 15,
    //   backgroundColor: "#a5a5a5",
    // },
  },
  iconEmptyBox: {
    fill: theme.palette.text.disabled,
  },
  boxDumpPages: {
    backgroundColor: alpha(theme.palette.error.main, 0.1),
    padding: "0px 5px",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
    width: "fit-content",
    ml: 2,
  },
  boxFreePages: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    padding: "0px 5px",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
    width: "fit-content",
    ml: 2,
  },
  alert: {
    mb: 2,
    backgroundColor: alpha(theme.palette.warning.main, 0.08),
    borderRadius: "5px",
  },
});

export default useStyles;
